module.exports = __webpack_public_path__ + "img/junction-icon.ef92e18b.svg";